import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Container from '../Container';

const defaultProps = {
  inline: false,
  direction: '',
  alignItems: '',
  justifyContent: '',
  className: '',
  children: null,
};

const propTypes = {
  inline: PropTypes.bool,
  direction: PropTypes.oneOf([
    'col',
    'row',
    '',
  ]),
  alignItems: PropTypes.oneOf([
    'center',
    'start',
    'end',
    '',
  ]),
  justifyContent: PropTypes.oneOf([
    'center',
    'start',
    'end',
    '',
  ]),
  className: PropTypes.string,
  children: PropTypes.node,
};

const Flex = ({
  inline,
  direction,
  alignItems,
  justifyContent,
  className,
  children,
  ...rest
}) => (
  <Container
    className={classnames(
      !inline && 'flex',
      inline && 'flex-inline',
      direction && `flex-${direction}`,
      alignItems && `items-${alignItems}`,
      justifyContent && `justify-${justifyContent}`,
      className,
    )}
    {...rest}
  >
    {children}
  </Container>
);

Flex.defaultProps = defaultProps;
Flex.propTypes = propTypes;

export default Flex;
